'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _EaApi = require('./../api/EaApi');

var _EaApi2 = _interopRequireDefault(_EaApi);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Obec Field
 *
 * Obec Suggest field
 */
var ObecField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ObecField, _AbstractReactCompone);

    function ObecField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ObecField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ObecField.__proto__ || (0, _getPrototypeOf2.default)(ObecField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            if (value && value.length > 1) {
                // hledáme až od dvou znaků!
                return _EaApi2.default.findObce(value);
            } else {
                return new _promise2.default(function (resolve, reject) {
                    resolve([]);
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ObecField, [{
        key: 'render',
        value: function render() {
            var other = (0, _objectWithoutProperties3.default)(this.props, []);


            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                minCharsForFilter: 3,
                placeholder: 'Vyhledat obec...',
                removable: true,
                filterSuggestions: this.handleFilterSuggestions,
                getItemValue: function getItemValue(item) {
                    return item ? item.nazevObec + " (" + item.nazevOkres + ")" : "";
                },
                renderSuggestion: function renderSuggestion(i, active, getItemValue) {
                    return _react2.default.createElement(
                        'div',
                        { className: active ? "active" : "" },
                        i.nazevObec + " (" + i.nazevOkres + ")"
                    );
                }
            }, other));
        }
    }]);
    return ObecField;
}(_AbstractReactComponent2.default);

ObecField.PropTypes = {
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};
ObecField.defaultProps = {
    apiRequestDelay: 250
};
exports.default = ObecField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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